import React from "react";
import Reveal from "./Reveal";

const SectionHeading = ({ eyebrow, title, subtitle, align = "center", light = false }) => {
  const alignClass = align === "left" ? "text-left items-start" : "text-center items-center mx-auto";
  return (
    <Reveal className={`flex flex-col ${alignClass} max-w-3xl mb-12 md:mb-16`}>
      {eyebrow && <span className="section-eyebrow mb-4 block">{eyebrow}</span>}
      <h2 className="font-display font-bold uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl text-foreground leading-tight">
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-4 text-base md:text-lg text-muted-foreground leading-relaxed ${light ? "text-muted-foreground" : ""}`}>
          {subtitle}
        </p>
      )}
    </Reveal>
  );
};

export default SectionHeading;
